import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ProductRangePage = lazy(() => import('../pages/product-range/page'));
const ARangeDetailsPage = lazy(() => import('../pages/a-range-details/page'));
const ZRangeDetailsPage = lazy(() => import('../pages/z-range-details/page'));
const XRangeDetailsPage = lazy(() => import('../pages/x-range-details/page'));
const MRangeDetailsPage = lazy(() => import('../pages/m-range-details/page'));
const ProductSpecificationsPage = lazy(() => import('../pages/product-specifications/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BuyerGuidePage = lazy(() => import('../pages/modular-pod-buyers-guide/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const SolutionPage = lazy(() => import('../pages/solutions/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/product-range',
    element: <ProductRangePage />
  },
  {
    path: '/a-range-details',
    element: <ARangeDetailsPage />
  },
  {
    path: '/z-range-details',
    element: <ZRangeDetailsPage />
  },
  {
    path: '/x-range-details',
    element: <XRangeDetailsPage />
  },
  {
    path: '/m-range-details',
    element: <MRangeDetailsPage />
  },
  {
    path: '/product-specifications',
    element: <ProductSpecificationsPage />
  },
  {
    path: '/contact',
    element: <ContactPage />
  },
  {
    path: '/modular-pod-buyers-guide',
    element: <BuyerGuidePage />
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />
  },
  {
    path: '/granny-flats-victoria',
    element: <SolutionPage />
  },
  {
    path: '/m5-residential-granny-flat',
    element: <SolutionPage />
  },
  {
    path: '/glamping-pods-australia',
    element: <SolutionPage />
  },
  {
    path: '/modular-cabins-for-resorts',
    element: <SolutionPage />
  },
  {
    path: '/backyard-office-pods-melbourne',
    element: <SolutionPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
